import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines, Label, Mark } from "./Reveal";

// Replace `image` with the preview image URL of each Instagram post (4:5 portrait works best).
// Until an image is set, a branded placeholder slot is shown. Links are preserved either way.
const POSTS = [
  { n: "01", url: "https://www.instagram.com/p/DY3jpxbpmKr/", image: "/ig-01.png", pos: "center 22%" },
  { n: "02", url: "https://www.instagram.com/p/DZH6_2spL-M/", image: "/ig-02.png", pos: "center 30%" },
  { n: "03", url: "https://www.instagram.com/p/DZtgKlYBrm1/", image: "/ig-03.png", pos: "center 87%" },
  { n: "04", url: "https://www.instagram.com/p/Db0GD4uJ-FA/", image: "/ig-04.png", pos: "center 35%" },
];

export default function InstagramJournal() {
  return (
    <section id="journal" className="py-28 md:py-40" data-testid="instagram-journal-section">
      <div className="max-w-[1600px] mx-auto px-6 md:px-10">
        <div className="max-w-[1200px] mx-auto">
          <Label>03 — From the journal</Label>

          <div className="mt-10 grid md:grid-cols-12 gap-8 items-end">
            <h2 className="md:col-span-6 font-serif serif-tactile font-light text-ink text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-[-0.01em]">
              <MaskLines lines={["From the", <em key="i" className="italic text-forest">journal.</em>]} />
            </h2>
            <div className="md:col-span-5 md:col-start-8">
              <Reveal>
                <p className="text-base md:text-lg leading-relaxed text-smoke" data-testid="instagram-intro">
                  My personal journey discovering forests, farmers, the ecosystem and the coffee through my lens
                </p>
              </Reveal>
            </div>
          </div>
        </div>

        <div
          className="mt-14 md:mt-20 flex md:grid md:grid-cols-4 gap-5 md:gap-8 overflow-x-auto md:overflow-visible snap-x snap-mandatory no-scrollbar -mx-6 px-6 md:mx-0 md:px-0"
          data-testid="instagram-gallery"
        >
          {POSTS.map((p, i) => (
            <Reveal key={p.n} delay={i * 0.1} className="w-[76vw] sm:w-[46vw] md:w-auto shrink-0 snap-start">
              <a
                href={p.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group relative block aspect-[4/5] overflow-hidden"
                data-testid={`instagram-tile-${p.n}`}
                aria-label={`View Instagram post ${p.n} in a new tab`}
              >
                {p.image ? (
                  <img
                    src={p.image}
                    alt={`Anichya Coffee Instagram post ${p.n}`}
                    style={{ objectPosition: p.pos || "center" }}
                    className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
                  />
                ) : (
                  <div className="h-full w-full bg-paper2 flex flex-col items-center justify-center gap-5 transition-colors duration-500 group-hover:bg-linen/50">
                    <Mark className="w-9 h-9 text-forest/25" />
                    <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-smoke/70">
                      Post N° {p.n}
                    </p>
                  </div>
                )}
                <span className="absolute left-4 bottom-4 flex items-center gap-1.5 bg-paper/90 backdrop-blur-sm text-ink text-[10px] uppercase tracking-[0.2em] px-3.5 py-2 opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
                  View on Instagram
                  <ArrowUpRight className="w-3.5 h-3.5" />
                </span>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal className="mt-14 md:mt-16 flex justify-center md:justify-start md:pl-2">
          <a
            href="https://www.instagram.com/shenoyoncoffee/"
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3"
            data-testid="instagram-follow-link"
          >
            <span className="font-serif serif-tactile italic font-light text-lg md:text-xl text-ink">
              Follow along
            </span>
            <span className="text-smoke">→</span>
            <span className="link-underline text-xs uppercase tracking-[0.2em] text-forest">
              @shenoyoncoffee
            </span>
            <ArrowUpRight className="w-4 h-4 text-chestnut transition-transform duration-500 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
